<template>
  <div class="v-range-int__main-wrapper">
    <span v-if="label" class="v-range-int__label">{{ label }}</span>
    <div class="v-range-int__range-wrapper">
      <div class="value-container">
        <span class="from-to">From</span>
        <span v-if="firstFixed" class="fixed-number">{{ first }}</span>
        <VNumberInput
          v-else
          extraClass="range-input"
          :initialNumber="first"
          @change="val => onChange(val, 'first')"
        />
      </div>
      <div class="value-container">
        <span class="from-to">To</span>
        <span v-if="lastFixed" class="fixed-number">{{ last }}</span>
        <VNumberInput
          v-else
          extraClass="range-input"
          :initialNumber="last || 1"
          @change="val => onChange(val, 'last')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VNumberInput from "@/components/VNumberInput";

export default Vue.component("VRangeIntInput", {
  props: {
    value: VueTypes.object.def({ first: 1, last: 1 }),
    label: VueTypes.string,
    firstFixed: VueTypes.bool.def(false),
    lastFixed: VueTypes.bool.def(false)
  },

  components: {
    VNumberInput
  },

  data() {
    return {
      first: this.value.first || 1,
      last: this.value.last || 1
    };
  },

  methods: {
    onChange(value, position) {
      this[position] = value;
      this.$emit("change", { first: this.first, last: this.last });
    }
  },

  watch: {
    value(val) {
      const { first, last } = val;

      if (first) {
        this.first = first;
      }

      if (this.last) {
        this.last = last;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-range-int";

.#{$ns} {
  &__main-wrapper /deep/ .range-input .v-number-input__input-wrapper{
    height: 20px;
  }

  &__label {
    display: inline-block;
    font-family: Lato-Bold, Arial, sans-serif;
    font-size: 16px;
    line-height: 1;
    color: $title-text-color;
    margin-bottom: 30px;
  }

  &__range-wrapper {
    display: flex;
    font-family: Lato-Regular, Arial, sans-serif;
    font-style: normal;
    font-size: 12px;
    line-height: 14px;

    > div:first-child {
      margin-right: 15px;
    }
  }
}

.value-container {
  display: flex;
  align-items: center;
}

.fixed-number {
  margin-left: 10px;
}

.from-to {
  display: inline-block;
  font-family: Lato-Light, Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
}
</style>
